export default __webpack_public_path__ + "static/comparison-headline-image-improved-412c988080338e871b775d2160833a87.png";